import Api from "@/services/Api";

export default {
  get(id) {
    return Api().get("assets/" + id);
  },

  getAsBase64(id) {
    return Api()
      .get("assets/" + id, { responseType: "arraybuffer" })
      .then(response => {
        let image = btoa(new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), ""));
        return `data:${response.headers["content-type"].toLowerCase()};base64,${image}`;
      });
  },
  upload(file) {
    return Api().post("assets/upload", { file: file });
  }
};
